module.exports = __webpack_public_path__ + "img/theater2.1fc9fa0e.jpg";